var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn primary_black",attrs:{"type":"button"},on:{"click":function($event){return _vm.returnToLogin()}}},[_vm._v(" Return to Log in ")])
}
var staticRenderFns = []

export { render, staticRenderFns }